export default __webpack_public_path__ + "static/media/usability.689381b8.png";